/** How My Requests shows the requests on a screen wide enough to offer the choice. */
export type RequestView = "tiles" | "table";

export const requestViews: readonly RequestView[] = ["tiles", "table"];

/** Per-viewer convenience only: the choice is remembered on this browser and never sent anywhere. */
const storageKey = "aia-portal.myRequestsView";

/** Reads the remembered view. Storage can be blocked or unavailable, so any failure falls back to the tiles. */
export function readStoredRequestView(): RequestView {
  try {
    const stored = window.localStorage.getItem(storageKey);
    return requestViews.find((view) => view === stored) ?? "tiles";
  } catch {
    return "tiles";
  }
}

/** Remembers the view for the next visit. A failed write only means the choice lasts for this visit. */
export function storeRequestView(view: RequestView): void {
  try {
    window.localStorage.setItem(storageKey, view);
  } catch {
    // Storage is unavailable; the in-memory choice still applies.
  }
}
